import cx from "classnames";

import useTypedContext from "hooks/useTypedContext";

import Button, { ButtonProps } from "../Button";
import Tooltip from "../Tooltip";
import { SplitControlContext } from "./context";
import styles from "./styles.module.css";

type SplitControlButtonProps = Omit<ButtonProps, "variant" | "size"> & { tooltip?: string };

const SplitControlButton = ({ tooltip, ...resetProps }: SplitControlButtonProps) => {
  const { variant, size } = useTypedContext(SplitControlContext);

  return (
    <Tooltip
      active={!!tooltip}
      on={(tooltipProps) => (
        <Button
          {...tooltipProps}
          {...resetProps}
          variant={variant}
          size={size}
          className={cx(tooltipProps.className, resetProps.className, styles.splitControlButton)}
        />
      )}
      placement="top"
    >
      {tooltip}
    </Tooltip>
  );
};

SplitControlButton.displayName = "DS.SplitControl.Button";

export default SplitControlButton;
